// Regional Hub + Location / House Pages (Tier 5)
const pages = [
  // ---------------- Regional hubs ----------------
  {
    slug: '/recovery-housing-lehigh-valley-pa/',
    category: 'Regional Hub', tier: 'Tier 5',
    name: 'Recovery Housing Lehigh Valley PA',
    primaryKeyword: 'Recovery Housing Lehigh Valley PA',
    keywords: ['sober living Lehigh Valley PA', 'recovery house Lehigh Valley', 'recovery homes near Allentown'],
    title: 'Lehigh Valley Recovery Housing | PGSRH Homes in PA',
    description: 'PGSRH recovery housing serves the Lehigh Valley, PA \u2014 men\u2019s homes in Whitehall and a women\u2019s home in Catasauqua. Explore locations and apply.',
    blurb: 'Regional hub connecting both PGSRH homes across the Lehigh Valley.',
    heroSubtitle: 'Recovery housing across the Lehigh Valley \u2014 two homes serving Allentown, Bethlehem, Easton, and the surrounding communities.',
    intro: [
      'The Lehigh Valley is home to all of PGSRH\u2019s recovery residences. Whether you\u2019re near Allentown, Bethlehem, Easton, or the towns in between, our homes keep you close to the meetings, employers, and family that support recovery.',
      'This regional hub connects our two houses: men\u2019s recovery housing in Whitehall, and women\u2019s recovery housing in Catasauqua.',
    ],
    whoFor: [
      'People in the Lehigh Valley seeking structured, sober housing',
      'Individuals who want to stay near local support and family',
      'Families searching regionally for a recovery home',
      'Referral partners placing clients across the Valley',
    ],
    sections: [
      { h: 'Two homes, one region', p: [
        'Our men\u2019s home in Whitehall and our women\u2019s home in Catasauqua all sit within the greater Lehigh Valley. That regional focus means residents rarely have to leave the community they\u2019re rebuilding in.',
        'Each home is substance-free, structured, and grounded in peer support.',
      ] },
      { h: 'Find your location', p: [
        'Use the links below to explore each city and gender-specific home, or compare men\u2019s and women\u2019s options through our hubs.',
        'Not sure which fits? Contact us and we\u2019ll help you choose based on location and availability.',
      ] },
    ],
    faqs: [
      { q: 'What areas does PGSRH serve?', a: 'The greater Lehigh Valley, including Allentown, Bethlehem, Easton, and nearby communities, through homes in Whitehall and Catasauqua.' },
      { q: 'Do you have men\u2019s and women\u2019s housing?', a: 'Yes. The men\u2019s home is in Whitehall; a women\u2019s home is in Catasauqua.' },
      { q: 'Is this treatment?', a: 'No. PGSRH provides recovery housing with peer support, not clinical treatment.' },
      { q: 'Is regional funding available?', a: 'County, state, scholarship, or assistance options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: true,
  },
  {
    slug: '/sober-living-lehigh-valley-pa/',
    category: 'Regional Hub', tier: 'Tier 5',
    name: 'Sober Living Lehigh Valley PA',
    primaryKeyword: 'Sober Living Lehigh Valley PA',
    keywords: ['sober living homes Lehigh Valley', 'sober housing Lehigh Valley'],
    title: 'Sober Living in the Lehigh Valley, PA | PGSRH',
    description: 'PGSRH sober living serves the Lehigh Valley, PA with structured, substance-free homes for men and women in Whitehall and Catasauqua. Explore and apply.',
    blurb: 'Regional sober living hub for the Lehigh Valley.',
    heroSubtitle: 'Sober living homes across the Lehigh Valley \u2014 structured, substance-free, and close to the support you rely on.',
    intro: [
      'If you\u2019re searching for sober living in the Lehigh Valley, PGSRH operates structured, substance-free homes for men and women throughout the region. Sober living and recovery housing mean the same thing here.',
      'Our homes in Whitehall and Catasauqua keep residents near meetings, jobs, and family.',
    ],
    whoFor: [
      'People seeking sober living in the Lehigh Valley',
      'Individuals leaving treatment who want to stay local',
      'Families comparing sober living options regionally',
      'Referral partners placing clients across the Valley',
    ],
    sections: [
      { h: 'Sober living across the Valley', p: [
        'Each PGSRH home provides a substance-free environment, clear expectations, and peer support. The men\u2019s home is in Whitehall; a women\u2019s home is in Catasauqua.',
        'Staying local keeps residents connected to the routines and relationships that support recovery.',
      ] },
      { h: 'Choosing a home', p: [
        'Decide between men\u2019s and women\u2019s sober living, then compare the city pages for the closest fit.',
        'Contact us to learn what is currently open and how the application works.',
      ] },
    ],
    faqs: [
      { q: 'Is sober living the same as recovery housing here?', a: 'Yes. At PGSRH the terms describe the same structured, substance-free housing with peer support.' },
      { q: 'Where are the sober living homes?', a: 'In Whitehall (men) and Catasauqua (women), all in the Lehigh Valley.' },
      { q: 'Does sober living include treatment?', a: 'No. It is housing with peer support, not clinical treatment.' },
      { q: 'Is funding available?', a: 'Scholarship or funding options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: true,
  },
  {
    slug: '/mens-recovery-housing-lehigh-valley-pa/',
    category: 'Regional Hub', tier: 'Tier 5', gender: 'men',
    name: "Men's Recovery Housing Lehigh Valley PA",
    primaryKeyword: "Men's Recovery Housing Lehigh Valley PA",
    keywords: ["men's sober living Lehigh Valley", 'male recovery housing Lehigh Valley'],
    title: "Men's Recovery Housing in the Lehigh Valley, PA | PGSRH",
    description: "PGSRH men's recovery housing serves the Lehigh Valley, PA with structured, sober homes in Whitehall. Peer support and accountability. Apply today.",
    blurb: "Regional men's hub linking Whitehall home.",
    heroSubtitle: 'Men\u2019s recovery housing across the Lehigh Valley \u2014 our home in Whitehall, built on brotherhood and accountability.',
    intro: [
      'Men in the Lehigh Valley have a PGSRH recovery home in Whitehall. It offers a structured, substance-free environment and a community of men working toward the same goals.',
      'This regional hub links the two men\u2019s houses so you can compare locations and availability.',
    ],
    whoFor: [
      'Men in the Lehigh Valley seeking sober, structured housing',
      'Men leaving treatment who want to stay near support',
      'Families searching for men\u2019s recovery housing in the region',
      'Referral partners placing male clients locally',
    ],
    sections: [
      { h: 'Two men\u2019s homes to choose from', p: [
        'Whitehall (855 3rd Street) provides substance-free living, clear expectations, and peer accountability. The location keeps residents close to work, family, and community support.',
        'Explore each city page to see which home fits best.',
      ] },
      { h: 'Brotherhood and structure', p: [
        'Living with other men in recovery builds accountability and camaraderie. Residents share responsibilities and support one another day to day.',
        'Reach out and we\u2019ll help you decide between Whitehall based on availability.',
      ] },
    ],
    faqs: [
      { q: 'Where are the men\u2019s homes in the Lehigh Valley?', a: 'In Whitehall, PA (855 3rd Street).' },
      { q: 'Can I choose between the two locations?', a: 'Yes, based on availability and what keeps you closest to work, family, and support. We\u2019ll help you decide.' },
      { q: 'Is this treatment?', a: 'No. It is structured, sober housing with peer support, not clinical treatment.' },
      { q: 'Is funding available?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: true,
  },
  {
    slug: '/womens-recovery-housing-lehigh-valley-pa/',
    category: 'Regional Hub', tier: 'Tier 5', gender: 'women',
    name: "Women's Recovery Housing Lehigh Valley PA",
    primaryKeyword: "Women's Recovery Housing Lehigh Valley PA",
    keywords: ["women's sober living Lehigh Valley", 'female recovery housing Lehigh Valley'],
    title: "Women's Recovery Housing in the Lehigh Valley, PA | PGSRH",
    description: "PGSRH women's recovery housing serves the Lehigh Valley, PA with a safe, structured, sober home in Catasauqua. Peer support and accountability. Apply today.",
    blurb: "Regional women's hub linking to the Catasauqua home.",
    heroSubtitle: 'Women\u2019s recovery housing in the Lehigh Valley \u2014 a safe, structured, sober home in Catasauqua built on support and trust.',
    intro: [
      'Women in the Lehigh Valley can turn to PGSRH\u2019s women\u2019s recovery home in Catasauqua \u2014 a safe, substance-free environment with a supportive community.',
      'This regional hub connects women\u2019s recovery housing searches to our Catasauqua location.',
    ],
    whoFor: [
      'Women in the Lehigh Valley seeking sober, structured housing',
      'Women leaving treatment who want to stay near support',
      'Families searching for women\u2019s recovery housing in the region',
      'Referral partners placing female clients locally',
    ],
    sections: [
      { h: 'A women\u2019s home in Catasauqua', p: [
        'PGSRH\u2019s women\u2019s recovery home at 425 Walnut Street in Catasauqua offers a safe, substance-free environment and a community of women supporting one another.',
        'Being in the Lehigh Valley keeps residents close to meetings, employers, and family.',
      ] },
      { h: 'Safety and support', p: [
        'A women-specific home fosters the safety and trust that help residents focus on recovery. Peer support and clear expectations anchor daily life.',
        'Visit our Catasauqua page for location details, or contact us about availability.',
      ] },
    ],
    faqs: [
      { q: 'Where is the women\u2019s home in the Lehigh Valley?', a: 'At 425 Walnut Street, Catasauqua, PA 18032.' },
      { q: 'Is this treatment?', a: 'No. It is structured, sober housing with peer support, not clinical treatment.' },
      { q: 'How does a woman apply?', a: 'Apply online or call 610-443-0175. Families and referral partners can reach out too.' },
      { q: 'Is funding available?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: true,
  },

  // ---------------- Whitehall (men) ----------------
  {
    slug: '/recovery-housing-whitehall-pa/',
    category: 'Location / House Page', tier: 'Tier 5', gender: 'men', city: 'Whitehall',
    name: 'Recovery Housing Whitehall PA',
    primaryKeyword: 'Recovery Housing Whitehall PA',
    keywords: ['sober living Whitehall PA', 'recovery house Whitehall PA', 'recovery homes Whitehall PA'],
    title: 'Recovery Housing in Whitehall, PA | PGSRH Men\u2019s Home',
    description: 'PGSRH men\u2019s recovery housing in Whitehall, PA (855 3rd Street) offers a structured, sober home with peer support. Ask about availability and funding options.',
    blurb: 'Our men\u2019s recovery house in Whitehall, PA (855 3rd Street).',
    heroSubtitle: 'A structured, sober men\u2019s recovery home in Whitehall, PA \u2014 close to Lehigh Valley meetings, jobs, and family.',
    intro: [
      'PGSRH\u2019s Whitehall recovery house is a men\u2019s home at 855 3rd Street, Whitehall, PA 18052. It provides a substance-free environment, clear expectations, and a community of men supporting one another in recovery.',
      'Whitehall keeps residents close to Allentown-area meetings, employers, and transportation \u2014 the everyday support that helps recovery stick.',
    ],
    whoFor: [
      'Men seeking recovery housing in or near Whitehall, PA',
      'Men leaving treatment who need a stable, sober home',
      'Families searching for a Whitehall men\u2019s recovery house',
      'Referral partners placing male clients in the area',
    ],
    sections: [
      { h: 'The Whitehall men\u2019s home', p: [
        'The home offers structured, substance-free living with shared responsibilities and peer accountability. Residents keep a routine \u2014 work, meetings, chores \u2014 supported by others on the same path.',
        'Its Whitehall location provides easy access to nearby recovery meetings, jobs, and public transportation.',
      ] },
      { h: 'Local resources and connection', p: [
        'Staying local matters. Residents remain close to family, employers, and the community resources they rely on while living in a supportive home.',
        'Contact us to ask about current openings at the Whitehall house.',
      ] },
    ],
    faqs: [
      { q: 'Where exactly is the Whitehall recovery house?', a: 'It is located at 855 3rd Street, Whitehall, PA 18052 \u2014 a men\u2019s recovery home.' },
      { q: 'Is the Whitehall home for men or women?', a: 'The Whitehall house is men\u2019s recovery housing.' },
      { q: 'How do I ask about availability?', a: 'Call 570-579-7695 or apply online. We\u2019ll let you know what is currently open.' },
      { q: 'Is funding available for the Whitehall house?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    fundingHeading: 'Funding questions for Whitehall',
    funding: true,
  },
  {
    slug: '/mens-recovery-housing-whitehall-pa/',
    category: 'Location / House Page', tier: 'Tier 5', gender: 'men', city: 'Whitehall',
    name: "Men's Recovery Housing Whitehall PA",
    primaryKeyword: "Men's Recovery Housing Whitehall PA",
    keywords: ['male recovery housing Whitehall PA', "men's recovery home Whitehall"],
    title: "Men's Recovery Housing in Whitehall, PA | PGSRH",
    description: "PGSRH men's recovery housing in Whitehall, PA (855 3rd Street) provides a structured, sober home with brotherhood and accountability. Ask about availability.",
    blurb: "The men's-specific view of our Whitehall recovery home.",
    heroSubtitle: 'Men\u2019s recovery housing in Whitehall, PA \u2014 a structured, sober home built on brotherhood and accountability.',
    intro: [
      'PGSRH\u2019s Whitehall home is dedicated men\u2019s recovery housing at 855 3rd Street, Whitehall, PA 18052. It\u2019s designed for men who want the accountability and camaraderie that a men\u2019s home provides.',
      'Residents live alongside other men in recovery, sharing responsibilities and supporting one another day to day.',
    ],
    whoFor: [
      'Men who want gender-specific recovery housing in Whitehall',
      'Men leaving treatment who need brotherhood and structure',
      'Families searching for a men\u2019s home in Whitehall',
      'Referral partners placing male clients locally',
    ],
    sections: [
      { h: 'Why a men\u2019s home', p: [
        'Many men recover best surrounded by other men who understand the pressures and habits involved. The Whitehall house creates that environment with clear expectations and a supportive community.',
        'It\u2019s a substance-free home focused on routine, responsibility, and peer accountability.',
      ] },
      { h: 'In the heart of the Lehigh Valley', p: [
        'Whitehall keeps residents close to Allentown-area meetings, employers, and transportation, so they can rebuild a stable daily life while living in a supportive home.',
        'Ask us about current openings for men at the Whitehall house.',
      ] },
    ],
    faqs: [
      { q: 'Is the Whitehall home men-only?', a: 'Yes. The Whitehall house is dedicated men\u2019s recovery housing at 855 3rd Street, Whitehall, PA 18052.' },
      { q: 'Is this a treatment program?', a: 'No. It is structured, sober housing with peer support, not clinical treatment.' },
      { q: 'How do I apply?', a: 'Call 570-579-7695 or apply online. Families and referral partners can reach out too.' },
      { q: 'Is funding available?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: true,
  },
  {
    slug: '/mens-sober-living-whitehall-pa/',
    category: 'Location / House Page', tier: 'Tier 5', gender: 'men', city: 'Whitehall',
    name: "Men's Sober Living Whitehall PA",
    primaryKeyword: "Men's Sober Living Whitehall PA",
    keywords: ['male sober living Whitehall PA', 'sober living for men Whitehall'],
    title: "Men's Sober Living in Whitehall, PA | PGSRH",
    description: "PGSRH men's sober living in Whitehall, PA (855 3rd Street) offers a substance-free home with peer accountability for men in recovery. Ask about availability.",
    blurb: "Men's sober living terminology for the Whitehall home.",
    heroSubtitle: 'Men\u2019s sober living in Whitehall, PA \u2014 a substance-free home with peers who share the same commitment.',
    intro: [
      'Searching for men\u2019s sober living in Whitehall? PGSRH\u2019s Whitehall house at 855 3rd Street is a men\u2019s sober living home \u2014 the same structured, substance-free housing many people call a recovery house.',
      'It offers routine, accountability, and a community of men focused on staying sober.',
    ],
    whoFor: [
      'Men seeking sober living in Whitehall, PA',
      'Men who want peer accountability and structure',
      'Men transitioning from treatment who want to stay local',
      'Families looking for men\u2019s sober living in Whitehall',
    ],
    sections: [
      { h: 'Sober living, Whitehall', p: [
        'The home keeps a substance-free standard with clear expectations everyone follows. Living with peers who share the goal makes daily sobriety more sustainable.',
        'Whitehall\u2019s location keeps residents close to meetings, jobs, and family in the Lehigh Valley.',
      ] },
      { h: 'Same home, familiar words', p: [
        'Whether you call it sober living or recovery housing, it\u2019s the same Whitehall men\u2019s home with the same structure and support.',
        'Contact us to ask what\u2019s currently open.',
      ] },
    ],
    faqs: [
      { q: 'Is men\u2019s sober living the same as the Whitehall recovery house?', a: 'Yes. It\u2019s the same men\u2019s home at 855 3rd Street, Whitehall \u2014 "sober living" and "recovery housing" describe the same thing.' },
      { q: 'Is it a treatment program?', a: 'No. It is sober housing with peer support, not clinical treatment.' },
      { q: 'How do I apply?', a: 'Call 570-579-7695 or apply online.' },
      { q: 'Is funding available?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: true,
  },
  {
    slug: '/recovery-house-whitehall-pa/',
    category: 'Location / House Page', tier: 'Tier 5', gender: 'men', city: 'Whitehall',
    name: 'Recovery House Whitehall PA',
    primaryKeyword: 'Recovery House Whitehall PA',
    keywords: ['recovery home Whitehall PA', 'recovery homes Whitehall', 'sober house Whitehall'],
    title: 'Recovery House in Whitehall, PA | PGSRH Men\u2019s Home',
    description: 'PGSRH operates a men\u2019s recovery house in Whitehall, PA at 855 3rd Street \u2014 a structured, sober home with peer support. Ask about availability and funding options.',
    blurb: 'Recovery house / recovery home terminology for Whitehall.',
    heroSubtitle: 'A men\u2019s recovery house in Whitehall, PA \u2014 a real home with structure, peers, and daily accountability.',
    intro: [
      'Looking for a recovery house or recovery home in Whitehall? PGSRH\u2019s men\u2019s house at 855 3rd Street is exactly that \u2014 a substance-free household of men supporting one another in recovery.',
      'It combines the feel of a home with the structure recovery needs.',
    ],
    whoFor: [
      'Men who want a recovery house in Whitehall, PA',
      'Men who prefer a home-style, structured environment',
      'Families searching for a Whitehall recovery home',
      'Referral partners placing male clients locally',
    ],
    sections: [
      { h: 'A home, not an institution', p: [
        'The Whitehall recovery house feels like a home: shared spaces, shared responsibilities, and neighbors in recovery who look out for one another. Clear expectations keep it substance-free and dependable.',
        'That homelike stability is a big part of why recovery housing works.',
      ] },
      { h: 'Rooted in Whitehall', p: [
        'The home\u2019s Whitehall location keeps residents connected to Lehigh Valley meetings, employers, and family.',
        'Reach out to ask about current openings.',
      ] },
    ],
    faqs: [
      { q: 'Is the Whitehall recovery house the same as your recovery housing there?', a: 'Yes. "Recovery house," "recovery home," and "recovery housing" all describe our men\u2019s home at 855 3rd Street, Whitehall.' },
      { q: 'Who lives there?', a: 'Adult men in recovery committed to a substance-free lifestyle and house expectations.' },
      { q: 'How do I apply?', a: 'Call 570-579-7695 or apply online.' },
      { q: 'Is funding available?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: true,
  },
  {
    slug: '/sober-living-whitehall-pa/',
    category: 'Location / House Page', tier: 'Tier 5', gender: 'men', city: 'Whitehall',
    name: 'Sober Living Whitehall PA',
    primaryKeyword: 'Sober Living Whitehall PA',
    keywords: ['sober living homes Whitehall PA', 'sober housing Whitehall PA'],
    title: 'Sober Living in Whitehall, PA | PGSRH',
    description: 'PGSRH sober living in Whitehall, PA (855 3rd Street) offers a structured, substance-free home for men in recovery. Ask about availability and funding options.',
    blurb: 'Local sober living terminology for the Whitehall home.',
    heroSubtitle: 'Sober living in Whitehall, PA \u2014 a structured, substance-free men\u2019s home close to Lehigh Valley support.',
    intro: [
      'People searching for sober living in Whitehall will find PGSRH\u2019s men\u2019s home at 855 3rd Street. It provides the substance-free, structured environment sober living is known for.',
      'Residents keep a routine and support one another while staying close to local meetings and jobs.',
    ],
    whoFor: [
      'Men seeking sober living in Whitehall, PA',
      'Men who want structure and peer accountability',
      'Men staying local after treatment',
      'Families comparing Whitehall sober living options',
    ],
    sections: [
      { h: 'Local sober living', p: [
        'The Whitehall home offers everything sober living should: a substance-free environment, clear expectations, and a supportive community of men.',
        'Its location keeps residents near the Allentown-area resources they depend on.',
      ] },
      { h: 'Unique to Whitehall', p: [
        'Living here means easy access to nearby meetings, employers, and transportation while you rebuild routine in a supportive home.',
        'Contact us about current openings.',
      ] },
    ],
    faqs: [
      { q: 'Where is sober living in Whitehall located?', a: 'At 855 3rd Street, Whitehall, PA 18052 \u2014 a men\u2019s home.' },
      { q: 'Is it the same as recovery housing?', a: 'Yes. Sober living and recovery housing describe the same home and standards.' },
      { q: 'How do I apply?', a: 'Call 570-579-7695 or apply online.' },
      { q: 'Is funding available?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: true,
  },


  // ---------------- Catasauqua (women) ----------------
  {
    slug: '/recovery-housing-catasauqua-pa/',
    category: 'Location / House Page', tier: 'Tier 5', gender: 'women', city: 'Catasauqua',
    name: 'Recovery Housing Catasauqua PA',
    primaryKeyword: 'Recovery Housing Catasauqua PA',
    keywords: ['sober living Catasauqua PA', 'recovery house Catasauqua PA', 'recovery homes Catasauqua PA'],
    title: 'Recovery Housing in Catasauqua, PA | PGSRH Women\u2019s Home',
    description: 'PGSRH women\u2019s recovery housing in Catasauqua, PA (425 Walnut Street) offers a safe, structured, sober home with peer support. Ask about availability and funding options.',
    blurb: 'Our women\u2019s recovery house in Catasauqua, PA (425 Walnut Street).',
    heroSubtitle: 'A safe, structured, sober women\u2019s recovery home in Catasauqua, PA \u2014 close to Lehigh Valley meetings, jobs, and family.',
    intro: [
      'PGSRH\u2019s Catasauqua recovery house is a women\u2019s home at 425 Walnut Street, Catasauqua, PA 18032. It provides a safe, substance-free environment, clear expectations, and a community of women supporting one another in recovery.',
      'Catasauqua keeps residents close to Lehigh Valley meetings, employers, and transportation.',
    ],
    whoFor: [
      'Women seeking recovery housing in or near Catasauqua, PA',
      'Women leaving treatment who need a stable, sober home',
      'Families searching for a Catasauqua women\u2019s recovery house',
      'Referral partners placing female clients in the area',
    ],
    sections: [
      { h: 'The Catasauqua women\u2019s home', p: [
        'The home offers safe, substance-free living with shared responsibilities and peer support. Residents keep a routine supported by other women on the same path.',
        'Its Catasauqua location provides easy access to nearby meetings, jobs, and public transportation.',
      ] },
      { h: 'Safety, trust, and connection', p: [
        'A women-specific home fosters safety and trust. Residents stay close to family, employers, and community resources while living in a supportive environment.',
        'Contact us to ask about current openings at the Catasauqua house.',
      ] },
    ],
    faqs: [
      { q: 'Where exactly is the Catasauqua recovery house?', a: 'It is located at 425 Walnut Street, Catasauqua, PA 18032 \u2014 a women\u2019s recovery home.' },
      { q: 'Is the Catasauqua home for men or women?', a: 'The Catasauqua house is women\u2019s recovery housing.' },
      { q: 'How do I ask about availability?', a: 'Call 610-443-0175 or apply online. We\u2019ll let you know what is currently open.' },
      { q: 'Is funding available for the Catasauqua house?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    fundingHeading: 'Funding questions for Catasauqua',
    funding: true,
  },
  {
    slug: '/womens-recovery-housing-catasauqua-pa/',
    category: 'Location / House Page', tier: 'Tier 5', gender: 'women', city: 'Catasauqua',
    name: "Women's Recovery Housing Catasauqua PA",
    primaryKeyword: "Women's Recovery Housing Catasauqua PA",
    keywords: ['female recovery housing Catasauqua PA', "women's recovery home Catasauqua"],
    title: "Women's Recovery Housing in Catasauqua, PA | PGSRH",
    description: "PGSRH women's recovery housing in Catasauqua, PA (425 Walnut Street) provides a safe, structured, sober home with peer support. Ask about availability.",
    blurb: "The women's-specific view of our Catasauqua recovery home.",
    heroSubtitle: 'Women\u2019s recovery housing in Catasauqua, PA \u2014 a safe, structured, sober home built on support and trust.',
    intro: [
      'PGSRH\u2019s Catasauqua home is dedicated women\u2019s recovery housing at 425 Walnut Street, Catasauqua, PA 18032, designed for women who want the safety and support a women\u2019s home provides.',
      'Residents live alongside other women in recovery, sharing responsibilities and encouraging one another daily.',
    ],
    whoFor: [
      'Women who want gender-specific recovery housing in Catasauqua',
      'Women leaving treatment who need safety and structure',
      'Families searching for a women\u2019s home in Catasauqua',
      'Referral partners placing female clients locally',
    ],
    sections: [
      { h: 'Why a women\u2019s home', p: [
        'Many women recover best in an environment built around safety, trust, and shared understanding. The Catasauqua house creates that with clear expectations and a supportive community.',
        'It\u2019s a substance-free home focused on routine, responsibility, and peer support.',
      ] },
      { h: 'In the Lehigh Valley', p: [
        'Catasauqua keeps residents close to Lehigh Valley meetings, employers, and transportation while they rebuild a stable daily life.',
        'Ask us about current openings for women at the Catasauqua house.',
      ] },
    ],
    faqs: [
      { q: 'Is the Catasauqua home women-only?', a: 'Yes. The Catasauqua house is dedicated women\u2019s recovery housing at 425 Walnut Street, Catasauqua, PA 18032.' },
      { q: 'Is this a treatment program?', a: 'No. It is structured, sober housing with peer support, not clinical treatment.' },
      { q: 'How do I apply?', a: 'Call 610-443-0175 or apply online.' },
      { q: 'Is funding available?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: true,
  },
  {
    slug: '/womens-sober-living-catasauqua-pa/',
    category: 'Location / House Page', tier: 'Tier 5', gender: 'women', city: 'Catasauqua',
    name: "Women's Sober Living Catasauqua PA",
    primaryKeyword: "Women's Sober Living Catasauqua PA",
    keywords: ['female sober living Catasauqua PA', 'sober living for women Catasauqua'],
    title: "Women's Sober Living in Catasauqua, PA | PGSRH",
    description: "PGSRH women's sober living in Catasauqua, PA (425 Walnut Street) offers a safe, substance-free home with peer support for women. Ask about availability.",
    blurb: "Women's sober living terminology for the Catasauqua home.",
    heroSubtitle: 'Women\u2019s sober living in Catasauqua, PA \u2014 a safe, substance-free home with peers who understand and support one another.',
    intro: [
      'Searching for women\u2019s sober living in Catasauqua? PGSRH\u2019s Catasauqua house is a women\u2019s sober living home \u2014 the same structured, substance-free housing often called a recovery house.',
      'It offers safety, routine, and a supportive community of women.',
    ],
    whoFor: [
      'Women seeking sober living in Catasauqua, PA',
      'Women who want safety, structure, and peer support',
      'Women transitioning from treatment who want to stay local',
      'Families looking for women\u2019s sober living in Catasauqua',
    ],
    sections: [
      { h: 'Sober living, Catasauqua', p: [
        'The home keeps a substance-free standard with shared expectations. Living with other women in recovery fosters safety and encouragement day to day.',
        'Its location keeps residents close to Lehigh Valley meetings, jobs, and family.',
      ] },
      { h: 'Same home, familiar words', p: [
        'Whether you call it sober living or recovery housing, it\u2019s the same Catasauqua women\u2019s home with the same structure and support.',
        'Contact us to ask what\u2019s currently open.',
      ] },
    ],
    faqs: [
      { q: 'Is women\u2019s sober living the same as the Catasauqua recovery house?', a: 'Yes. It\u2019s the same women\u2019s home at 425 Walnut Street, Catasauqua \u2014 the terms describe the same thing.' },
      { q: 'Is it a treatment program?', a: 'No. It is sober housing with peer support, not clinical treatment.' },
      { q: 'How do I apply?', a: 'Call 610-443-0175 or apply online.' },
      { q: 'Is funding available?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: true,
  },
  {
    slug: '/recovery-house-catasauqua-pa/',
    category: 'Location / House Page', tier: 'Tier 5', gender: 'women', city: 'Catasauqua',
    name: 'Recovery House Catasauqua PA',
    primaryKeyword: 'Recovery House Catasauqua PA',
    keywords: ['recovery home Catasauqua PA', 'recovery homes Catasauqua', 'sober house Catasauqua'],
    title: 'Recovery House in Catasauqua, PA | PGSRH Women\u2019s Home',
    description: 'PGSRH operates a women\u2019s recovery house in Catasauqua, PA at 425 Walnut Street \u2014 a safe, structured, sober home. Ask about availability and funding options.',
    blurb: 'Recovery house / recovery home terminology for Catasauqua.',
    heroSubtitle: 'A women\u2019s recovery house in Catasauqua, PA \u2014 a real home with safety, structure, and daily support.',
    intro: [
      'Looking for a recovery house or recovery home in Catasauqua? PGSRH\u2019s women\u2019s house at 425 Walnut Street is exactly that \u2014 a substance-free household of women supporting one another in recovery.',
      'It combines the feel of a home with the structure and safety recovery needs.',
    ],
    whoFor: [
      'Women who want a recovery house in Catasauqua, PA',
      'Women who prefer a home-style, structured environment',
      'Families searching for a Catasauqua recovery home',
      'Referral partners placing female clients locally',
    ],
    sections: [
      { h: 'A home, not an institution', p: [
        'The Catasauqua recovery house feels like a home: shared spaces, shared responsibilities, and neighbors in recovery who look out for one another. Clear expectations keep it substance-free and safe.',
        'That homelike stability is a big part of why recovery housing works.',
      ] },
      { h: 'Rooted in Catasauqua', p: [
        'The home\u2019s Catasauqua location keeps residents connected to Lehigh Valley meetings, employers, and family.',
        'Reach out to ask about current openings.',
      ] },
    ],
    faqs: [
      { q: 'Is the Catasauqua recovery house the same as your recovery housing there?', a: 'Yes. "Recovery house," "recovery home," and "recovery housing" all describe our women\u2019s home at 425 Walnut Street, Catasauqua.' },
      { q: 'Who lives there?', a: 'Adult women in recovery committed to a substance-free lifestyle and house expectations.' },
      { q: 'How do I apply?', a: 'Call 610-443-0175 or apply online.' },
      { q: 'Is funding available?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: true,
  },
  {
    slug: '/sober-living-catasauqua-pa/',
    category: 'Location / House Page', tier: 'Tier 5', gender: 'women', city: 'Catasauqua',
    name: 'Sober Living Catasauqua PA',
    primaryKeyword: 'Sober Living Catasauqua PA',
    keywords: ['sober living homes Catasauqua PA', 'sober housing Catasauqua PA'],
    title: 'Sober Living in Catasauqua, PA | PGSRH',
    description: 'PGSRH sober living in Catasauqua, PA (425 Walnut Street) offers a safe, structured, substance-free home for women in recovery. Ask about availability.',
    blurb: 'Local sober living terminology for the Catasauqua home.',
    heroSubtitle: 'Sober living in Catasauqua, PA \u2014 a safe, structured, substance-free women\u2019s home close to Lehigh Valley support.',
    intro: [
      'People searching for sober living in Catasauqua will find PGSRH\u2019s women\u2019s home at 425 Walnut Street. It provides the safe, substance-free, structured environment sober living is known for.',
      'Residents keep a routine and support one another while staying close to local meetings and jobs.',
    ],
    whoFor: [
      'Women seeking sober living in Catasauqua, PA',
      'Women who want safety, structure, and peer support',
      'Women staying local after treatment',
      'Families comparing Catasauqua sober living options',
    ],
    sections: [
      { h: 'Local sober living', p: [
        'The Catasauqua home offers everything sober living should: a safe, substance-free environment, clear expectations, and a supportive community of women.',
        'Its location keeps residents near the Lehigh Valley resources they depend on.',
      ] },
      { h: 'Unique to Catasauqua', p: [
        'Living here means access to nearby meetings, employers, and transportation while you rebuild routine in a supportive home.',
        'Contact us about current openings.',
      ] },
    ],
    faqs: [
      { q: 'Where is sober living in Catasauqua located?', a: 'At 425 Walnut Street, Catasauqua, PA 18032 \u2014 a women\u2019s home.' },
      { q: 'Is it the same as recovery housing?', a: 'Yes. Sober living and recovery housing describe the same home and standards.' },
      { q: 'How do I apply?', a: 'Call 610-443-0175 or apply online.' },
      { q: 'Is funding available?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: true,
  },
];

export default pages;
